/**
 * Pure filtering logic for the guide review console (issue #219 AC5:
 * "Filter by category and state"). Split out from AdminGuides.jsx so the
 * filter behaviour — especially "all" meaning no predicate at all, not a
 * predicate that happens to match everything — is unit-testable without a
 * mounted component or a network mock.
 */

export const STATE_FILTERS = [
  { value: "all", label: "All states" },
  { value: "unreviewed", label: "Unreviewed" },
  { value: "published", label: "Published" },
];

/** Category options, derived from whatever the console actually loaded —
 * NOT the full nine-folder set (`content/schema/guide.ts`'s `CATEGORIES`),
 * because a category with nothing imported yet would offer a filter that
 * always empties the list. Alphabetical, "All categories" first. */
export function categoryOptions(guides) {
  const seen = [...new Set(guides.map((g) => g.category))].sort((a, b) => a.localeCompare(b));
  return [{ value: "all", label: "All categories" }, ...seen.map((c) => ({ value: c, label: c.replace(/-/g, " ") }))];
}

export function filterGuides(guides, { category, state }) {
  return guides.filter((g) => {
    if (category && category !== "all" && g.category !== category) return false;
    if (state && state !== "all" && g.state !== state) return false;
    return true;
  });
}
